import { put, call } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';

import api, { apiLogin } from 'services/api';
import { providersAPI } from 'services/apiRest';

import ProvidersActions from '../ducks/providers';
// import AuthActions from '../ducks/auth';

export function* getProviders() {
  try {
    // Usar API REST ao invés de Firebase
    const providers = yield call(providersAPI.listar);
    
    // Converter formato se necessário
    const providersFormatados = providers.map((provider) => ({
      ...provider,
      created_at: provider.created_at 
        ? { seconds: Math.round(new Date(provider.created_at).getTime() / 1000) }
        : { seconds: Math.round(Date.now() / 1000) },
    }));

    yield put(ProvidersActions.getProvidersSuccess(providersFormatados));
  } catch (err) {
    console.error('Erro ao buscar providers:', err);
    yield put(ProvidersActions.getProvidersFailure(err));
  }
}

export function* addProvider({ provider, closeModal }) {
  try {
    // Usar API REST ao invés de Firebase
    const providerCriado = yield call(providersAPI.criar, provider);

    // Converter formato
    const data = {
      ...providerCriado,
      created_at: providerCriado.created_at 
        ? { seconds: Math.round(new Date(providerCriado.created_at).getTime() / 1000) }
        : { seconds: Math.round(Date.now() / 1000) },
    };

    yield put(ProvidersActions.addProviderSuccess(data));
    
    if (closeModal) closeModal();
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'EMPRESA',
        message: 'Cadastro realizado com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao cadastrar provider:', err);
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao cadastrar empresa',
        message: err.message || 'Tente novamente',
      })
    );

    yield put(ProvidersActions.addProviderFailure(err));
  }
}
export function* updateProvider({ provider, closeModal }) {
  try {
    // Usar API REST ao invés de Firebase
    const providerAtualizado = yield call(providersAPI.atualizar, provider.id, provider);

    // Converter formato
    const uploadData = {
      ...providerAtualizado,
      created_at: provider.created_at || 
        (providerAtualizado.created_at 
          ? { seconds: Math.round(new Date(providerAtualizado.created_at).getTime() / 1000) }
          : { seconds: Math.round(Date.now() / 1000) }),
    };

    yield put(ProvidersActions.updateProviderSuccess(uploadData));

    yield put(
      toastrActions.add({
        type: 'success',
        title: 'EMPRESA',
        message: 'Atualizada com sucesso!',
      })
    );
    
    if (closeModal) closeModal();
  } catch (err) {
    console.error('Erro ao atualizar provider:', err);
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao atualizar a empresa',
        message: err.message || 'Tente novamente',
      })
    );

    yield put(ProvidersActions.updateProviderFailure(err));
  }
}

export function* removeProvider({ id }) {
  try {
    // Usar API REST ao invés de Firebase
    yield call(providersAPI.deletar, id);

    yield put(ProvidersActions.removeProviderSuccess());
    yield put(ProvidersActions.getProvidersRequest());
  } catch (err) {
    console.error('Erro ao remover provider:', err);
    yield put(ProvidersActions.removeProviderFailure(err));
  }
}
